import React from "react";

export const KAKAO_CHAT_URL = "https://pf.kakao.com/_RPggG/chat";

export function KakaoIcon({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M16 3C8.3 3 2 7.9 2 14c0 3.9 2.6 7.4 6.5 9.3L7 29l6.7-4.2c.8.1 1.5.2 2.3.2 7.7 0 14-4.9 14-11S23.7 3 16 3Z" />
      <text x="16" y="16.5" textAnchor="middle" fill="#fee500" fontFamily="Arial, sans-serif" fontSize="8" fontWeight="800">TALK</text>
    </svg>
  );
}

export default function KakaoInquiry() {
  return (
    <a className="ik-kakao-inquiry" href={KAKAO_CHAT_URL} target="_blank" rel="noopener noreferrer" aria-label="카카오톡 문의하기 (새 창)">
      <KakaoIcon />
      <span>카카오톡<strong>문의하기</strong></span>
    </a>
  );
}
